module.exports = __webpack_public_path__ + "img/customer.blue.c55ec390.png";